import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'beach-beach-baby',
  name: 'Beach Beach Baby',
  location: 'Panama City Beach',
  area: 'West End',
  bedrooms: '9',
  bathrooms: '11',
  sleeps: 'Up to 28',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2023/08/1.jpg',
  matterportUrl: 'https://my.matterport.com/show/?m=EZkwZeoM24X&mls=1',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2023/08/1.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/2.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/3.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/3B.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/4.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/4A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/5.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/6.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/7.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/8.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/8A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/9.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/10.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/11.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/12.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/12A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/13.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/14.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/15.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/15A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/15B.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/16.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/17.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/18.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/19.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/20.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/21.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/23.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/24.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/25.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/26.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/27.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/28.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/28A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/29.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/30.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/31.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/32.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/33.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/33A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/33B.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/34.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/35.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/36.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/37.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/37A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/38.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/38A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/39.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/40.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/40A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/41.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/42.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/43.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/44.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/45.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/46.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/47.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/47A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/48.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/49.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/50.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/51.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/51A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/52.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/53.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/54.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/55.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/55A.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/56.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/57.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/58.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/59.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/60.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/61.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/62.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/63.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/64.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/65.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/66.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/67.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/68.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/69.jpg',
  'https://inspirevp.com/wp-content/uploads/2023/08/70.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `Beach Beach Baby photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'The beach is out front, the pool is out back, and there\u2019s plenty of room for everyone.',
  paragraphs: [
    'Beach Beach Baby is a coastal craftsman home on the quiet West End of Panama City Beach. Built in 2023, it spans three levels with more than 5,200 square feet of indoor living space, massive outdoor balconies, and sweeping Gulf views from Level 2 and Level 3.',
    'The home is designed for a large group that wants to stay together without losing space. It has nine bedrooms, eleven bathrooms, two great rooms, a large open-concept layout, and an elevator serving all three levels.',
    'Level 2 is the central gathering area, with a massive great room, Gulf views, an expansive outdoor deck, and a chef-ready kitchen with quartz countertops, a large island, a 48-inch Sub-Zero refrigerator, a Wolf six-burner range, and two dishwashers.',
    'Outside, the pool and hot tub create the main hangout space. The outdoor living area includes lounge chairs, a dining table, rocking chairs, a gas grill, and an outdoor shower.',
    'Beach access is directly out the front door, leading to a quieter stretch of sand. The home is also close to 30A, Rosemary Beach, Alys Beach, Pier Park, Publix Sports Complex, and Frank Brown Park.',
  ],
  locationContext:
    'Beach Beach Baby is located on the quiet West End of Panama City Beach, minutes from scenic Highway 30A, Rosemary Beach, Alys Beach, Pier Park, Publix Sports Complex, and Frank Brown Park.',
  address: 'West End of Panama City Beach',
  addressSub: 'Panama City Beach, Florida',
  propertyMeta: '9 bedrooms · 11 bathrooms · 3 levels · Built in 2023',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Large Group Layout',
    body: 'Nine bedrooms and eleven bathrooms accommodate up to 28 guests in beds. Two great rooms, three levels, and generous shared spaces give large groups room to gather and room to spread out.',
    image: 'https://inspirevp.com/wp-content/uploads/2023/08/8.jpg',
    imageAlt: 'Beach Beach Baby gathering space',
    tag: 'Sleeps up to 28',
  },
  {
    title: 'Private Pool & Hot Tub',
    body: 'The outdoor living area centers on the private pool and hot tub. The pool can be heated for an additional fee, and the surrounding area includes lounge chairs, dining space, rocking chairs, a gas grill, and an outdoor shower.',
    image: 'https://inspirevp.com/wp-content/uploads/2023/08/3.jpg',
    imageAlt: 'Beach Beach Baby private pool and hot tub',
    tag: 'Private pool · Hot tub',
  },
  {
    title: 'Gulf View Balconies',
    body: 'Massive outdoor balconies on Level 2 and Level 3 provide sweeping Gulf views. The Level 2 great room and the two Gulf-front primary suites on Level 3 open into the strongest views.',
    image: 'https://inspirevp.com/wp-content/uploads/2023/08/2.jpg',
    imageAlt: 'Beach Beach Baby Gulf view balcony',
    tag: 'Level 2 · Level 3',
  },
  {
    title: 'Chef-Ready Kitchen',
    body: 'The kitchen features quartz countertops, a huge island, a 48-inch Sub-Zero refrigerator, a Wolf six-burner range, two dishwashers, and multiple dining areas for a full house.',
    image: 'https://inspirevp.com/wp-content/uploads/2023/08/10.jpg',
    imageAlt: 'Beach Beach Baby kitchen',
    tag: 'Level 2',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '9 bedrooms',
      '11 bathrooms',
      'Sleeps up to 28 guests',
      'More than 5,200 sq. ft. over 3 levels',
      'New construction, built in 2023',
      'West End of Panama City Beach',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Private pool and hot tub (heated for an additional fee)',
      'Elevator serving all 3 levels',
      'Beach access directly out the front door',
      'Massive Level 2 and Level 3 balconies with Gulf views',
      'Amazing outdoor living area',
      'Outdoor shower',
      'Pet friendly (additional fee)',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      'Quartz countertops',
      'Huge island',
      '48-inch Sub-Zero refrigerator',
      'Wolf 6-burner range',
      '2 dishwashers',
      'Dining table seats 8',
      'Additional seating at high-top table and kitchen island',
    ],
  },
  {
    heading: 'The bedrooms',
    items: [
      'Level 1: Bedroom 1, king bed and two twin bunk beds',
      'Level 1: Bedroom 2, king bed and two twin bunk beds',
      'Level 1: Bedroom 3, two queen-over-queen bunk beds',
      'Level 2: Bedroom 4, king bed',
      'Level 2: Bedroom 5, king bed',
      'Level 3: Bedrooms 6 and 7, king beds',
      'Level 3: two Gulf-front primary suites, each with king bed',
    ],
  },
  {
    heading: 'Outdoor living',
    items: [
      'Private pool',
      'Hot tub',
      '8 lounge chairs',
      'Dining table with seating for 8',
      'Several rocking chairs',
      'Gas grill',
      'Outdoor shower',
    ],
  },
  {
    heading: 'The area',
    items: [
      'Quiet West End of Panama City Beach',
      'Direct beach access out the front door',
      'Minutes from scenic Highway 30A',
      'Close to Rosemary Beach and Alys Beach',
      'Close drive to Pier Park',
      'Close to Publix Sports Complex and Frank Brown Park',
    ],
  },
];

export const reviews: PropertyReview[] = [];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'beach-beach-baby',
  propertyName: 'Beach Beach Baby',
  introText:
    'Hello — I’m here to help you get to know Beach Beach Baby. Ask about group size, the pool and hot tub, the elevator, beach access, or whether it fits your trip.',
  seedQuestion: 'Would this work for 24 guests?',
  starters: [
    'How many guests does it sleep?',
    'Tell me about the pool and hot tub.',
    'Does it have an elevator?',
    'What is the beach access like?',
    'Does it work for large groups?',
    'Does it allow pets?',
    'What is nearby?',
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: 'Beach Beach Baby',
  propertyLocation: 'Panama City Beach',
  sleeps: '28',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'beach-beach-baby',
  propertyName: 'Beach Beach Baby',
  location: 'West End · Panama City Beach',
  bedrooms: '9 bed',
  sleeps: 'Sleeps 28',
};

export const bayCountyCertificateId = '46552';
